import { PopoverOrigin } from '@mui/material';

import {
  colors,
  fonts,
  mainHeight,
  menuPaper,
  sizes,
  thinScrollbar,
} from '../../theme';

const styles = {
  // The page is dimmed like under a drawer; the side menu stays as it is. A click anywhere closes.
  backdropProps: {
    transitionDuration: 120,
    sx: {
      background: `linear-gradient(90deg, transparent ${2 * sizes.gutter + sizes.sideNav}px, ${colors.overlay} ${2 * sizes.gutter + sizes.sideNav}px)`,
    },
  },
  // On the right of the side menu, the same gap as between the menu and the page.
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  } as PopoverOrigin,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  } as PopoverOrigin,
  paperProps: {
    sx: {
      ...menuPaper,
      ml: `${sizes.gutter}px`,
      width: 460,
      maxWidth: 'calc(100vw - 32px)',
      height: mainHeight,
      maxHeight: 'none',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
  },
  header: {
    flexShrink: 0,
    height: 52,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.border}`,
  },
  title: {
    fontFamily: fonts.text,
    fontSize: 15,
    fontWeight: 700,
    color: colors.text,
  },
  newCount: {
    fontFamily: fonts.text,
    fontSize: 12,
    color: colors.textSubtle,
  },
  list: {
    ...thinScrollbar,
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  empty: {
    py: 5,
    px: 2,
    textAlign: 'center',
    fontFamily: fonts.text,
    fontSize: 13,
    color: colors.textSubtle,
  },
  loading: {
    height: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    fontFamily: fonts.text,
    fontSize: 12,
    color: colors.textSubtle,
  },
  spinner: {
    color: colors.text,
  },
};

export default styles;
